class ImageController {
    constructor($scope,$state,userInfo,$filter, CollectionAPI,$stateParams, QueryAPI, $sce, pageTitle, ImgDetailRecommendListApi,
      message, modal, AppConfig, fancyboxService, $transitions,ImageAPI,Jurisdiction) {
        "ngInject";

        this.$stateParams = $stateParams;
        this.Jurisdiction = Jurisdiction;
        this.QueryAPI = QueryAPI;
        this.$sce = $sce;
        this.pageTitle = pageTitle;
        this.userInfo = userInfo;
        this.$scope = $scope;
        this.message = message;
        this.modal = modal;
        this.AppConfig = AppConfig;
        this.loading = true;
        this.$state = $state;
        this.ImageAPI=ImageAPI;
        this.CollectionAPI=CollectionAPI;
        this.ImgDetailRecommendListApi = ImgDetailRecommendListApi
        this.collectionActive=false;
        this.tranlsteFilter=$filter('translate');

        this.imgListTotal = 0
        this.showImgIndex=1;
        this.showImgList = [];



        this.isCC0=false;

        $scope.fancyboxOptions = fancyboxService.getOptions();

        $scope.setImageUnavailable = () => {
            $scope.imageUnavailable = true;
        };
        this.userInfo.setUser(this.appUser);

        let self = this;
        $transitions.onSuccess({
            to: (state) => {
                return state.name == 'app.page.original.image' || state.name == 'app.page.original.imageHash' || state.name == 'app.page.original.imageReproduction';
            }
        }, () => {
            self.init();
        });
        this.removeDialog={
            text:self.tranlsteFilter('page-original-text073'),
            sure:()=> {
                this.deleteImage(this.removeDialog.original)
            },
            show:(original,event) => {
                event.stopPropagation();
                this.removeDialog.original=original;
                this.removeDialog.text=self.tranlsteFilter('page-original-text074')+original.title+'" ?';
                this.removeDialog.isActive=true;
            }
        }
        this.init();
        this.changeShowImgPage("pre")

        
      //   console.log($stateParams)

    }

    init() {

        this.$scope.imageUnavailable = false;
        this.$scope.publicKeyHtml = '';

        this.showReproductionDetail = false;
        this.imageReproduction = null;

        this.$scope.image = null;

        this.setShowReproductionDetail({'show': false});
        this.setReproduction({'reproduction': null});

        if (this.image) {
            this.loadImage(this.image);
        } else {

            let api = null;

            if (this.$stateParams.id) {
                api = this.QueryAPI.one().get({'id': this.$stateParams.id, 'type': 'image'});
            } else if (this.$stateParams.hash) {
                api = this.QueryAPI.one('hash').get({'hash': this.$stateParams.hash, 'type': 'image'});
            } else if (this.$stateParams.reproduction) {
                api = this.QueryAPI.one('reproduction').get({'id': this.$stateParams.reproduction, 'type': 'image'});
            } else {
                this.setError({'error': true});
                return;
            }

            let self = this;

            api.then(
                function (image) {
                    self.loadImage(image);
                },
                function () {
                    self.loading = false;
                    self.setError({'error': true});
                }
            );
        }
    }

    loadImage(image) {
        let self = this;

        if(!image.license){
            image.user={};
            image.locked=0;
            image.title=self.tranlsteFilter('page-original-text075');
            image.license={type: "cc0", content: {adaptation: "y", commercial: "y"}};
            self.isCC0=true;
        }
        self.$scope.image = image;

        self.$scope.publicKeyHtml = self.$sce.trustAsHtml(image.public_key && image.public_key.replace(/\n/g, "<br/>"));

        self.pageTitle.setTitle(image.title + ' ' + image.author_name);

        if (image.reproduction) {
            // Comes from reproduction url
            // Display reproduction
            image.reproduction.author_name=image.author_name;
            image.reproduction.license=image.license;
            self.showReproductionDetail = true;
            self.setShowReproductionDetail({'show': true});
            self.setReproduction({'reproduction': image.reproduction});
            self.imageReproduction = image.reproduction;
            self.loading = false;
            self.pageLoaded();

        } else {
            self.loadReproduction();
        }

        //获取用户是否已经收藏
        if(!this.userInfo.isGuest()){
            this.collectionInfo(image)
        }
    }

    loadReproduction() {

        let self = this;
        if (!this.userInfo.isGuest()) {
            if (this.$scope.image.license.type) {
                this.QueryAPI.one().one('image', this.$scope.image.id).one('reproduction').get().then(
                    (reproduction) => {
                        if (reproduction && reproduction.id) {
                            self.showReproductionDetail = false;
                            self.setShowReproductionDetail({'show': false});
                            self.setReproduction({'reproduction': reproduction});
                            self.imageReproduction = reproduction;

                        }
                        self.pageLoaded();
                    },
                    (response) => {
                        self.pageLoaded();
                        self.message.error(response.data);
                    },
                );
            } else {
                this.pageLoaded();
            }
        } else {
            this.pageLoaded();
        }
    }

    pageLoaded() {
        this.loading = false;

        if(this.$scope.image.locked || this.$scope.image.user.locked) {
            this.message.error(this.tranlsteFilter('page-original-text037'), 0);
        }
    }

    get() {
        window.location = this.$scope.image.image_url;
    }

    showWeixinShare() {
        let url = this.AppConfig.server_url + '/original/qrcode?type=image&id=' + this.$scope.image.id;
        this.shareToWeixin({url: url});
    }
    deleteImage(image){

        let self = this;

        self.loading = true;

        this.ImageAPI.one(image.id).remove().then(
            (res) => {
                if(res.status.code==200){
                    self.appUser.image_count--;
                    self.message.success(self.tranlsteFilter('page-original-text076'));
                    self.$state.go('app.page.author',{id: image.uuid});
                }else if(res.status.code==422){
                    if(res.status.message=='Authorized'){
                        self.message.error(self.tranlsteFilter('page-original-text077'));
                    }else{
                        self.message.error(self.tranlsteFilter('page-original-text040'));
                    }
                }
                self.loading = false;

            },
            (response) => {
                self.loading = false;
                self.message.error(response.data);
            }
        );
    }
    //获取收藏属性
    collectionInfo(image){
        let self = this;
        this.CollectionAPI.one().get({'resource_type_id': self.isCC0?3:2, 'resource_id': image.id}).then(
            function (res) {
                self.collectionActive=res.data.active;
            },
            function () {
                // self.loading = false;
                // self.setError({'error': true});
            }
        );
    }
    collection(image){
        if(this.userInfo.isGuest()){
            this.$state.go('app.face.index.user.form.login');
            return;
        }
        let self = this;
        self.collection_loading = true;
        let api=this.CollectionAPI;
        if(self.collectionActive){
            api.one().remove({'resource_type_id': self.isCC0?3:2, 'resource_id': image.id}).then(
                () => {
                    self.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-original-text041'));
                    self.collectionActive=false
                },
                (response) => {
                    self.collection_loading = false;
                    self.message.error(response.data);
                }
            );
        }else{
            api.post({'resource_type_id': self.isCC0?3:2, 'resource_id': image.id}).then(
                () => {
                    self.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-original-text042'));
                    self.collectionActive=true
                },
                (response) => {
                    self.collection_loading = false;
                    self.message.error(response.data);
                }
            );
        }

    }
    collection_text(){
        let self = this;
        if(self.collection_loading){
            return self.tranlsteFilter('page-original-text043')
        }else{
            if(self.collectionActive){
                return self.tranlsteFilter('page-original-text044')
            }else{
                return self.tranlsteFilter('page-original-text045')
            }
        }
    }

    checkEditor(){
      this.permission = JSON.parse(window.localStorage.getItem("loginUser"))

      let param = Object.assign(this.permission);
      return this.Jurisdiction.checkStatusShow(param);
   }

   changeShowImgPage(type){

      switch(type){
         case "pre":this.showImgIndex --;break;
         case "next":this.showImgIndex ++;break;
      }
      if(this.showImgIndex <= 1){
         this.showImgIndex = 1
      }
      if(this.imgListTotal == 0){
         this.showImgIndex = 1
      }

      // if(this.showImgIndex * 4  >=  this.imgListTotal){
      //    this.showImgIndex=  this.imgListTotal
      // }

      this.getRecommendImgList()

   }
   getRecommendImgList(){
      let params = {
        page:this.showImgIndex,
        page_size:4,
        id:this.$stateParams.id,//imgId
      }

     this.ImgDetailRecommendListApi.get("",params).then(res=>{
        this.showImgList = res.recommends 
        this.imgListTotal = res.recommends.length
     })

   }

  


}

export default ImageController;



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-image/original-image.controller.js